module.exports = __webpack_public_path__ + "img/profile-avatar.8cf64c59.svg";